<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">

              <div class="row">
                <div class="col-lg-6 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.nama_jabatan" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Level <span class="text-danger">*</span></label>
                    <input type="number" v-model="currentData.level" placeholder="" required />
                  </div>
                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Insert</button>
                  <router-link to="jobtittle" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch } from "@/assets/js/function";


export default {
  // components: {
  //   Form,
  //   Field,
  // },
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Insert Job Tittle",
      title1: "add new Job Tittle",
      namaCompany: '',
      config: "",
      api: "",

      //data
      currentData: {
      },
      currentDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    this.namaCompany = localStorage.getItem('namaCompany');


    localStorage.setItem('actionState', 'insert')


  },
  
  methods: {

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },


    async insert() {
     
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const api = base_url + '/v3/jobtitle/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
          AlertBottom(data.message);
          goPage("jobtittle");
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      
    },

  },

};
</script>
